import axios from 'axios';

const state = () => ({
  tax_questions: {
    w_9: null,
    w_8ben: null,
    w_8ben_e: null,
    w_8ben_e_substitute: null,
    w_8eci: null,
    form_8233: null,
  },
  current_tax_form: 'w_9',
  current_tax_form_id: 1,
  section: 1,
  total_sections: 0,
  section_names: {},
  has_answers: false,
  tax_answers: null,
  tax_form_submission: {
    onboarding_packet_id: null,
    tax_form_id: 1,
    tax_answers_attributes: [],
  },
  tax_forms: [],
  w_9_tax_form_id: 1,
  bypass_w9_tax_form_id: 6,
  bypass_w8_tax_form_id: 7,
  has_submitted_bypass_w9: false,
  has_submitted_bypass_w8: false,
  latest_tax_form_submission: null,
  latest_company_tax_form_submission: null,
  latest_company_tax_form_submissions: {
    w_9: null,
    w_8ben: null,
    w_8ben_e: null,
    w_8ben_e_substitute: null,
    w_8eci: null,
    form_8233: null,
  },
  hasCheckedForTaxFormSubmission: {
    w_9: false,
    w_8ben: false,
    w_8ben_e: false,
    w_8ben_e_substitute: false,
    w_8eci: false,
    form_8233: false,
  },
  federal_tax_class: null,
  tax_number: null,
  llc_sub_classification: null,
  has_canadian_address: false,
  tax_question_toggle_required_count: 0,
  signer_name_tax_question_ids: [23, 190, 47, 231, 264],
  allW8Tins: ['bn', 'rfc', 'giin', 'ftin', 'sin', 'ein'],
  show_validation_errors: {
    w_9: true,
    w_8ben: true,
    w_8ben_e: true,
    w_8ben_e_substitute: false,
    w_8eci: true,
    form_8233: true,
  },
  tax_form_is_type_to_id: {
    form_8233: 5,
    w_8ben: 2,
    w_8ben_e: 3,
    w_8ben_e_substitute: 8,
    w_8eci: 4,
    w_9: 1,
  },
});

// getters
const getters = {
  tax_forms(state) {
    let objForms = {};

    //Convert the object in a different structure using the entries of the Object
    const forms = state.tax_forms;

    //Iterate and extract the value of the object
    forms.forEach((f) => {
      let is_type = f.is_type;
      objForms[is_type] = f.id;
    });

    return objForms;
  },
};

// actions

const actions = {
  async getTaxQuestions({ commit }, is_type) {
    try {
      let res = await axios.get(
        process.env.API_MONITOR +
          '/api/v1/tax_forms?page=1&per_page=1&q[is_type_eq]=' +
          is_type
      );
      commit('setTaxQuestions', { data: res.data, is_type: is_type });
      return res;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async submitTaxForm({ state, dispatch }) {
    let initVal = { ...state.tax_form_submission };
    // console.log("submitTaxForm");
    // console.dir(initVal);
    if (initVal?.tax_answers_attributes?.length > 0) {
      let valid_tax_answers_attributes = initVal.tax_answers_attributes.filter(
        (item) => item?.tax_form_id == state.current_tax_form_id
      );
      initVal.tax_answers_attributes = valid_tax_answers_attributes;
    }
    let data = {
      tax_form_submission: initVal,
    };
    // data['onboarding_packet_id'] = rootState.onboardingPacket.onboarding_id;
    // let wrapData = {
    //     tax_answer: data
    // };

    try {
      let res = await axios.post(
        process.env.API_MONITOR + '/api/v1/tax_form_submissions',
        data
      );
      if (res?.data?.id) {
        dispatch('getLatestTaxFormSubmission', res?.data?.id);
      }
      return res;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async submitBypassW9TaxForm({ state, rootState, commit }) {
    let data = {
      tax_form_submission: {
        onboarding_packet_id: rootState.onboardingPacket.onboarding_id,
        tax_form_id: state.bypass_w9_tax_form_id,
        is_active: true,
      },
    };

    try {
      let res = await axios.post(
        process.env.API_MONITOR + '/api/v1/tax_form_submissions',
        data
      );
      if (res?.data?.id) {
        // dispatch("getLatestTaxFormSubmission", res?.data?.id);
        commit('setHasSubmittedBypassW9', true);
      }
      return res;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async submitBypassW8TaxForm({ state, rootState, commit }) {
    let data = {
      tax_form_submission: {
        onboarding_packet_id: rootState.onboardingPacket.onboarding_id,
        tax_form_id: state.bypass_w8_tax_form_id,
        is_active: true,
      },
    };

    try {
      let res = await axios.post(
        process.env.API_MONITOR + '/api/v1/tax_form_submissions',
        data
      );
      if (res?.data?.id) {
        // dispatch("getLatestTaxFormSubmission", res?.data?.id);
        commit('setHasSubmittedBypassW8', true);
      }
      return res;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async getTaxForms({ commit }) {
    try {
      let res = await axios.get(process.env.API_MONITOR + '/api/v1/tax_forms');
      commit('setTaxForms', res.data);
      return res;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async submitAutoW9TaxForm({ state, dispatch }, onboarding_packet_id) {
    if (state.has_submitted_bypass_w9 == true) return;
    let body = {
      tax_form_submission: {
        onboarding_packet_id: onboarding_packet_id,
        tax_form_id: state.w_9_tax_form_id,
        is_active: true,
      },
    };
    try {
      let res = await axios.post(
        process.env.API_IDENTITY + '/api/v1/tax_form_submissions',
        body
      );
      if (res?.data?.id) {
        dispatch('getLatestTaxFormSubmission', res?.data?.id);
      }
      return res;
    } catch (e) {
      if (axios.isAxiosError(e) && [403, 422].includes(e.response?.status)) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async submitAutoW8TaxForm(
    { state, dispatch, rootState },
    onboarding_packet_id
  ) {
    if (state.has_submitted_bypass_w8 == true) return;
    let data = null;
    if (!state.current_tax_form) {
      data = state.latest_company_tax_form_submission?.onboarding_packet_body;
    } else {
      data =
        state.latest_company_tax_form_submissions?.[state.current_tax_form]
          ?.onboarding_packet_body;
    }
    // Update data to show new onboarding packet id
    if (data?.tax_form_submission?.onboarding_packet_id > 0) {
      data['tax_form_submission']['onboarding_packet_id'] =
        onboarding_packet_id;
      let answer_data = data?.tax_form_submission?.tax_answers_attributes;
      if (answer_data?.length > 0) {
        answer_data.forEach((answer) => {
          answer['onboarding_packet_id'] = onboarding_packet_id;
          // set Signer Name to current user's name if first_name and last_name are present on the user record
          if (
            state.signer_name_tax_question_ids.includes(
              answer?.tax_question_id
            ) &&
            rootState?.users?.currentUser?.first_name &&
            rootState?.users?.currentUser?.last_name &&
            answer?.['string_value'] &&
            `${rootState?.users?.currentUser?.first_name} ${rootState?.users?.currentUser?.last_name}` !==
              answer?.['string_value']
          ) {
            answer['string_value'] =
              `${rootState?.users?.currentUser?.first_name} ${rootState?.users?.currentUser?.last_name}`;
          }
        });
        data['tax_form_submission']['tax_answers_attributes'] = answer_data;
      }
    }

    try {
      let res = await axios.post(
        process.env.API_MONITOR + '/api/v1/tax_form_submissions',
        data
      );
      if (res?.data?.id) {
        dispatch('getLatestTaxFormSubmission', res?.data?.id);
      }
      return res;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async getLatestTaxFormSubmission({ commit, state, rootState }, id) {
    // console.log("running getLatestTaxFormSubmission for id: " + id);
    try {
      let res = await axios.get(
        process.env.API_MONITOR + '/api/v1/tax_form_submissions/' + id
        // "/api/v1/onboarding_packets/" + onboarding_packet_id + "/latest_tax_form_submission"
      );
      if (res?.data) {
        commit('setLatestTaxFormSubmission', res?.data);
        console.log('setCurrentTaxForm-4');
        if (
          rootState.company?.companyData?.allowed_w8_is_types?.length > 0 &&
          !rootState.company?.companyData?.allowed_w8_is_types?.includes(
            res?.data?.tax_form?.is_type
          )
        ) {
          commit(
            'addFormDebugMessage',
            "BYPASSING setCurrentTaxForm | VUEX | taxQuestions.js: latest_tax_form_submission is not in broker's allowed_w8_is_types",
            { root: true }
          );
          if (
            state.current_tax_form !== 'w_9' &&
            !rootState.company?.companyData?.allowed_w8_is_types?.includes(
              state.current_tax_form
            )
          ) {
            let w8_is_type =
              rootState.company?.companyData?.allowed_w8_is_types?.[0];
            if (w8_is_type && w8_is_type !== state.current_tax_form) {
              commit('setCurrentTaxForm', {
                is_type: w8_is_type,
                id: state.tax_form_is_type_to_id[w8_is_type],
              });
            }
          }
        } else {
          commit('setCurrentTaxForm', {
            is_type: res?.data?.tax_form?.is_type,
            id: res?.data?.tax_form?.id,
          });
        }
        commit('setLatestCompanyTaxFormSubmission', res?.data);
        commit('setLatestCompanyTaxFormSubmissions', {
          data: res?.data,
          is_type: res.data?.tax_form?.is_type,
        });
      }
      return res;
    } catch (e) {
      let status = e?.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e?.response;
      } else {
        throw e;
      }
    }
  },
  async getLatestCompanyTaxFormSubmission({ commit, rootState }) {
    let company_id = rootState.users?.currentUser?.company?.id;
    try {
      let res = await axios.get(
        process.env.API_MONITOR +
          '/api/v1/companies/' +
          company_id +
          '/show_latest_tax_form_submission'
      );
      if (res?.data) {
        commit('setLatestCompanyTaxFormSubmission', res?.data);
        commit('setLatestCompanyTaxFormSubmissions', {
          data: res?.data,
          is_type: res.data?.tax_form?.is_type,
        });
      }
      return res;
    } catch (e) {
      let status = e?.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e?.response;
      } else {
        throw e;
      }
    }
  },
  async getLatestCompanyTaxFormSubmissionByTaxFormIsType(
    { commit, rootState },
    is_type
  ) {
    if (!is_type) {
      return;
    }

    let company_id = rootState.users?.currentUser?.company?.id;
    try {
      let res = await axios.get(
        process.env.API_MONITOR +
          '/api/v1/companies/' +
          company_id +
          '/show_latest_tax_form_submission_by_tax_form_type?is_type=' +
          is_type
      );
      if ([200, 201].includes(res.status) && res?.data) {
        commit('setLatestCompanyTaxFormSubmissions', {
          data: res?.data,
          is_type: is_type,
        });
      }
      return res;
    } catch (e) {
      let status = e?.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        if (status == 404) {
          commit('setHasCheckedForTaxFormSubmission', {
            data: true,
            is_type: is_type,
          });
        }
        return e?.response;
      } else {
        throw e;
      }
    }
  },
  // async checkIfAnswersPresent({ rootState, commit }) {
  //     let companyQuestionsSections = rootState.carriers.carrierData?.company_question_sections;
  //     if (companyQuestionsSections?.length > 0) {
  //         companyQuestionsSections.forEach(function(cqs) {
  //             cqs?.company_questions.forEach(function(cq) {
  //                 if (cq?.question?.current_answer || cq?.question?.most_recent_previous_answer ) {
  //                     commit('setHasAnswers', true);
  //                     return;
  //                 }
  //             });
  //         });
  //     }
  // }
};

//mutations
const mutations = {
  setTaxQuestions(state, { data, is_type }) {
    state.tax_questions[is_type] = data;
  },
  setTaxForms(state, data) {
    state.tax_forms = data;
  },
  setCurrentTaxForm(state, { is_type, id }) {
    state.current_tax_form = is_type;
    state.current_tax_form_id = id;
  },
  setSection(state, el) {
    state.section = el;
  },
  setTotalSections(state, el) {
    state.total_sections = el;
  },
  setSectionName(state, el) {
    state.section_names = el;
  },
  setHasAnswers(state, el) {
    state.has_answers = el;
  },
  setTaxAnswers(state, data) {
    state.tax_answers = data;
    state.tax_form_submission['tax_answers_attributes'] = data;
  },
  setTaxFormSubmission(state, { prop, data }) {
    state.tax_form_submission[prop] = data;
  },
  setLatestTaxFormSubmission(state, data) {
    state.latest_tax_form_submission = data;
  },
  setLatestCompanyTaxFormSubmission(state, data) {
    state.latest_company_tax_form_submission = data;
  },
  setLatestCompanyTaxFormSubmissions(state, { data, is_type }) {
    state.latest_company_tax_form_submissions[is_type] = data;
  },
  setHasCheckedForTaxFormSubmission(state, { data, is_type }) {
    state.hasCheckedForTaxFormSubmission[is_type] = data;
  },
  setFederalTaxClass(state, data) {
    state.federal_tax_class = data;
  },
  setTaxNumber(state, data) {
    state.tax_number = data;
  },
  setLLCSubClassification(state, data) {
    state.llc_sub_classification = data;
  },
  setHasCanadianAddress(state, data) {
    state.has_canadian_address = data;
  },
  setIncrementTaxQuestionToggleRequiredCount(state) {
    state.tax_question_toggle_required_count += 1;
  },
  setHasSubmittedBypassW9(state, bool) {
    state.has_submitted_bypass_w9 = bool;
  },
  setHasSubmittedBypassW8(state, bool) {
    state.has_submitted_bypass_w8 = bool;
  },
  setShowValidationErrors(state, { is_type, bool }) {
    state.show_validation_errors[is_type] = bool;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
